import { api } from './api';
import type { TrackingHistory, ApiResponse } from '@/types';

export const trackingHistoryService = {
  getByShipmentId: async (shipmentId: number): Promise<ApiResponse<TrackingHistory[]>> => {
    const response = await api.get(`/api/Shipments/${shipmentId}/tracking`);
    return response.data;
  },
  create: async (data: Partial<TrackingHistory>): Promise<ApiResponse<TrackingHistory>> => {
    const response = await api.post('/tracking-history', data);
    return response.data;
  },
};
